<template>
  <v-dialog v-model="dialog" width="1200" persistent>
    <template v-slot:activator="{ on, attrs }">
      <v-btn @click="getAbsentPersons(1)" v-bind="attrs" v-on="on" icon>
        <v-icon color="success">mdi-flag</v-icon>
      </v-btn>
    </template>
    <v-card class="rounded-lg">
      <v-card-title class="pb-0">
        <v-row align="center" justify="space-between">
          <v-col class="px-0" cols="auto"></v-col>
          <v-col class="px-0" cols="auto">
            <p class="dialog-title">Отсутствующие персоны</p>
          </v-col>
          <v-col class="px-0" cols="auto">
            <v-btn icon @click="dialog = false">
              <v-icon size="30" color="error">mdi-close-thick</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text style="padding: 15px 40px">
        <v-container fluid class="px-5">
          <v-row class="options" align="center">
            <v-col cols="auto" class="pl-4">
              <p class="title">Кол-во строк</p>
            </v-col>
            <div style="width: 110px">
              <div class="input-wrapper">
                <v-select
                  @input="getAbsentPersons"
                  :items="pagination.limits"
                  v-model="pagination.limit"
                  hide-spin-buttons
                  hide-selected
                  hide-details
                  outlined
                  dense
                />
              </div>
            </div>
            <v-spacer />
          </v-row>
          <v-row class="options" align="center">
            <v-col cols="auto" class="pl-4">
              <p class="label">Филиал:</p>
            </v-col>
            <div style="width: 330px">
              <div class="input-wrapper">
                <v-select
                  @input="getAbsentPersons(1)"
                  :items="list"
                  v-model="params.branch"
                  item-text="title"
                  item-value="id"
                  hide-spin-buttons
                  hide-selected
                  hide-details
                  outlined
                  dense
                  clearable
                />
              </div>
            </div>
            <v-spacer />
            <v-col cols="auto">
              <v-row align="center">
                <v-col cols="auto">
                  <p>Период:</p>
                </v-col>
                <v-col cols="auto">
                  <v-menu
                    v-model="menuFrom"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <div class="input-wrapper" style="width: 160px">
                        <v-text-field
                          v-model="params.fromDate"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          outlined
                          hide-details
                        ></v-text-field>
                      </div>
                    </template>
                    <v-date-picker
                      v-model="params.fromDate"
                      @change="getAbsentPersons"
                      :max="params.toDate"
                      scrollable
                      @input="menuFrom = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="auto">
                  <p>-</p>
                </v-col>
                <v-col cols="auto">
                  <v-menu
                    v-model="menuTo"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <div class="input-wrapper" style="width: 160px">
                        <v-text-field
                          v-model="params.toDate"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          outlined
                          hide-details
                        ></v-text-field>
                      </div>
                    </template>
                    <v-date-picker
                      v-model="params.toDate"
                      @change="getAbsentPersons"
                      :min="params.fromDate"
                      :max="new Date().toISOString().substr(0, 10)"
                      scrollable
                      @input="menuTo = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-data-table
            class="elevation-1"
            :headers="headers"
            :items="items"
            :loading="loading"
            :search="search"
            loading-text="Пожалуйста подождите, данные загружаются..."
            hide-default-footer
          >
          </v-data-table>
          <custom-pagination
            @updatePage="getAbsentPersons($event)"
            :pagination="pagination"
          />
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import CustomPagination from "@/components/CustomPagination";
export default {
  name: "AbsentPersons",
  props: {
    list: {
      type: Array,
      required: true,
    },
  },
  components: { CustomPagination },
  data() {
    return {
      dialog: false,
      headers: [
        {
          text: "#",
          align: "start",
          sortable: true,
          value: "id",
        },
        {
          text: "ФИО",
          align: "start",
          sortable: true,
          value: "full_name",
        },
        {
          text: "ИИН",
          align: "start",
          sortable: true,
          value: "iin",
        },
        {
          text: "Филиал",
          align: "start",
          sortable: true,
          value: "branch.title",
        },
        {
          text: "Группа",
          align: "start",
          sortable: true,
          value: "group.title",
        },
        // {
        //   text: "Статус входа",
        //   align: "start",
        //   sortable: true,
        //   value: "status",
        // },
        // {
        //   text: "Статус выхода",
        //   align: "start",
        //   sortable: true,
        //   value: "status_exit",
        // },
        // {
        //   text: "Дата",
        //   align: "start",
        //   sortable: true,
        //   value: "date",
        // },
      ],
      pagination: {
        limit: 10,
        limits: [10, 50, 100],
        offset: 0,
        count: 0,
        page: 1,
        pages: 1,
      },
      params: {
        fromDate: new Date().toISOString().substr(0, 10),
        toDate: new Date(new Date().setDate(new Date().getDate() + 1))
          .toISOString()
          .substr(0, 10),
        branch: this.list.id,
      },
      menuFrom: false,
      menuTo: false,
      items: [],
      searchPerson: "",
      types: [
        {
          title: "Выход",
          value: "exit",
        },
        {
          title: "Вход",
          value: "enter",
        },
      ],
      branches: [],
      persons: [],
      loading: true,
      search: "",
    };
  },
  methods: {
    async getAbsentPersons(page = 1) {
      this.loading = true;
      this.items = [];
      this.pagination.page = page;
      this.pagination.offset =
        (this.pagination.page - 1) * this.pagination.limit;
      try {
        const response = await this.$axios.get("persons/absent-persons/", {
          params: {
            from_date: this.params.fromDate,
            to_date: this.params.toDate,
            limit: this.pagination.limit,
            offset: this.pagination.offset,
            branch_id: this.params.branch,
          },
        });
        this.items = response.data.results;
        this.loading = false;
        this.pagination.count = response.data.count;
        this.pagination.pages =
          Math.floor(this.pagination.count / this.pagination.limit) + 1;
      } catch (e) {
        this.loading = false;
        this.$root.$emit("showDefaultError");
      }
    },
    async getBranches() {
      try {
        const response = await this.$axios.get("organizations/branches/short/");
        response.data;
        this.branches = response.data;
      } catch (e) {
        this.$root.$emit("showDefaultError");
      }
    },
  },
};
</script>

<style scoped></style>
